import { render, staticRenderFns } from "./SetRules.vue?vue&type=template&id=6fb8035c&scoped=true&"
import script from "./SetRules.vue?vue&type=script&lang=js&"
export * from "./SetRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8035c",
  null
  
)

export default component.exports